module.exports = __webpack_public_path__ + "assets/webgl/card_050_DE_L0.174027ad.jpg";